import { Enum } from "@/commons/enums/Type";

export class FilterEnum {
  static NONE = { value: 0, jaText: "指定なし", enText: "NoFilter" };
  static BIDDER = { value: 1, jaText: "Bidder", enText: "Bidder" };
  static ADUNIT = { value: 2, jaText: "AdUnit", enText: "AdUnit" };
  static ADUNIT_GROUP = { value: 3, jaText: "AdUnitGroup", enText: "AdUnitGroup" };
  static DEVICE = { value: 4, jaText: "Device", enText: "Device" };
  static BROWSER = { value: 5, jaText: "Browser", enText: "Browser" };
  static OS = { value: 6, jaText: "OS", enText: "OS" };
  static BID_STATUS = { value: 7, jaText: "Bid Status", enText: "Bid Status" };
  static DOMAIN = { value: 8, jaText: "Domain", enText: "Domain" };
  static PUBLISHER = { value: 9, jaText: "Publisher", enText: "Publisher" };

  static getEnum() {
    return {
      NONE: { value: FilterEnum.NONE.value, text: FilterEnum.NONE.jaText },
      BIDDER: { value: FilterEnum.BIDDER.value, text: FilterEnum.BIDDER.jaText },
      ADUNIT: { value: FilterEnum.ADUNIT.value, text: FilterEnum.ADUNIT.jaText },
      ADUNIT_GROUP: {
        value: FilterEnum.ADUNIT_GROUP.value,
        text: FilterEnum.ADUNIT_GROUP.jaText,
      },
      DEVICE: { value: FilterEnum.DEVICE.value, text: FilterEnum.DEVICE.jaText },
      BROWSER: { value: FilterEnum.BROWSER.value, text: FilterEnum.BROWSER.jaText },
      OS: { value: FilterEnum.OS.value, text: FilterEnum.OS.jaText },
      BID_STATUS: { value: FilterEnum.BID_STATUS.value, text: FilterEnum.BID_STATUS.jaText },
      DOMAIN: { value: FilterEnum.DOMAIN.value, text: FilterEnum.DOMAIN.jaText },
      PUBLISHER: { value: FilterEnum.PUBLISHER.value, text: FilterEnum.PUBLISHER.jaText },
    };
  }
}

export interface FilterEnumInterface {
  NONE: Enum;
  BIDDER: Enum;
  ADUNIT: Enum;
  ADUNIT_GROUP: Enum;
  DEVICE: Enum;
  BROWSER: Enum;
  OS: Enum;
  BID_STATUS: Enum;
  DOMAIN: Enum;
  PUBLISHER: Enum;
}
